import { useState } from 'react'
import { SourceProps, LayerProps } from 'react-map-gl'
import type { Expression } from 'mapbox-gl'
import { SymbolLayer } from 'mapbox-gl'
import { paint, priority } from './common'

const socialURL = process.env.REACT_APP_SOCIAL_URL
const socialPostsEndpoint = 'api/socialPost/getAllSocialPostsGeoJson/'

type CustomSourceProps = SourceProps & {
  data: string
}

export const socialSource: CustomSourceProps = {
  id: 'social',
  type: 'geojson',
  data: `${socialURL}${socialPostsEndpoint}`,
  generateId: true
}

export const socialLayerStyle: SymbolLayer = {
  id: 'social',
  type: 'symbol',
  source: 'social',
  layout: {
    'text-field': ['get', 'title'],
    'text-anchor': 'top',
    'text-justify': 'center',
    'text-size': 14,
    'icon-anchor': 'bottom',
    'icon-image': 'userpost'
  },
  paint: paint
}

interface UseLayerPropsState {
  layerStyle: LayerProps
  toggleOpacity: (featureId?: string | number) => void
  layerVisibility: boolean
  setLayerVisibility: (layerVisibility: boolean) => void
  toggleLayerVisibility: (e?: boolean) => void
}

export const useSocialLayerStyle = (): UseLayerPropsState => {
  const [layerVisibility, setLayerVisibility] = useState(true)
  const [layerStyle, setLayerStyle] = useState<SymbolLayer>(socialLayerStyle)

  const toggleOpacity = (featureId?: string | number) => {
    if (featureId) {
      setLayerStyle(state => ({
        ...state,
        layout: {
          ...state.layout,
          'symbol-sort-key': ['match', ['id'], featureId, 0, priority]
        },
        paint: {
          ...state.paint,
          'icon-opacity': ['match', ['feature-state', 'active'], 1, 1, 0.5]
        }
      }))
    } else {
      setLayerStyle(state => ({
        ...state,
        paint: {
          ...state.paint,
          'icon-opacity': 1
        },
        layout: {
          ...state.layout,
          'symbol-sort-key': priority as Expression
        }
      }))
    }
  }

  const toggleLayerVisibility = (isVisible?: boolean) => {
    setLayerStyle(state => ({
      ...state,
      layout: {
        ...state.layout,
        visibility: isVisible ? ('visible' as const) : ('none' as const)
      }
    }))
  }

  return {
    layerStyle,
    toggleOpacity,
    layerVisibility,
    setLayerVisibility,
    toggleLayerVisibility
  }
}
